import React, { useState, useEffect, useRef } from "react";
import { Card, Container, Col, Row, CardBody } from "shards-react";
import { useHistory, useParams } from "react-router-dom";
import { db } from "../../../firebase";
import {
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  documentId,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where
} from "firebase/firestore";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { FormControlLabel, Switch } from "@mui/material";

function SubAdminDetails() {
  const { id } = useParams();
  const history = useHistory();

  // The raw list of assigned users
  const [assignedUserIds, setAssignedUserIds] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);

  // Filter: Valid only
  const [filterValidTill, setFilterValidTill] = useState(false);
  const [filteredAssignedUsers, setFilteredAssignedUsers] = useState([]);

  // For searching new users to add
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchedUsers, setSerchedUsers] = useState([]);
  const [searchEmail, setSearchEmail] = useState("");

  const [loading, setLoading] = useState(false);

  const AssignedUsersRef = useRef(assignedUsers);

  // On mount: load assignedUserIds from Firestore
  useEffect(() => {
    (async () => {
      // const unsubscribe = onSnapshot(doc(db, 'SubAdminData', id),(snap)=>{
      //   console.log("Current data: ", snap.data());
      //   setAssignedUserIds(snap.data().AssignedUsers ? snap.data().AssignedUsers : [])
      // })
      // return unsubscribe
      const docRef = doc(db, "SubAdminData", id);
      const adminSnapData = await getDoc(docRef);
      if (adminSnapData.exists()) {
        setAssignedUserIds(
          adminSnapData.data().AssignedUsers
            ? adminSnapData.data().AssignedUsers
            : []
        );
      }
    })();
  }, [id]);

  // Watch assignedUserIds, load user data from Firestore
  useEffect(() => {
    setAssignedUsers([]);
    let unsubscribe;
    if (assignedUserIds.length > 0) {
      let ids = [];
      for (let i = 0; i < assignedUserIds.length; i++) {
        ids.push(assignedUserIds[i]);
        // Process in batches of 10 to avoid "where in" limit
        if (ids.length === 10 || i === assignedUserIds.length - 1) {
          const collRef = collection(db, "UserData");
          const queryUsers = query(collRef, where(documentId(), "in", ids));

          unsubscribe = onSnapshot(queryUsers, data => {
            data.docChanges().forEach(async change => {
              let CalibScore = null;
              let sign = "flat";

              if (change.type === "added") {
                if (change.doc.data().CalibrateResult) {
                  let last_three = change.doc
                    .data()
                    .PrevCalibrationResult.slice(-3);
                  const docSnap = await getDoc(
                    change.doc.data().CalibrateResult
                  );
                  if (docSnap.exists()) {
                    CalibScore = roundOff(docSnap.data().CalibrationAvg);
                  }
                  if (CalibScore && last_three.length > 0) {
                    const docRef = collection(db, "CalibrateResult");
                    const docSnaps = query(
                      docRef,
                      where(documentId(), "in", last_three)
                    );
                    const ddd = await getDocs(docSnaps);
                    let last_three_score = 0;
                    ddd.forEach((a, index) => {
                      last_three_score =
                        last_three_score + a.data().CalibrationAvg;
                    });
                    last_three_score = last_three_score / 3;
                    if (last_three_score > CalibScore) {
                      sign = "down";
                    } else if (last_three_score < CalibScore) {
                      sign = "up";
                    }
                  }
                }
                setAssignedUsers(prevUsers => [
                  ...prevUsers,
                  { uid: change.doc.id, ...change.doc.data(), CalibScore, sign }
                ]);
              }
              if (change.type === "modified") {
                let newArray = [...AssignedUsersRef.current];
                let index = newArray.findIndex(
                  user => change.doc.id === user.uid
                );
                if (change.doc.data().CalibrateResult) {
                  let last_three = change.doc
                    .data()
                    .PrevCalibrationResult.slice(-3);
                  const docSnap = await getDoc(
                    change.doc.data().CalibrateResult
                  );
                  if (docSnap.exists()) {
                    CalibScore = roundOff(docSnap.data().CalibrationAvg);
                  }
                  if (CalibScore && last_three.length > 0) {
                    const docRef = collection(db, "CalibrateResult");
                    const docSnaps = query(
                      docRef,
                      where(documentId(), "in", last_three)
                    );
                    const ddd = await getDocs(docSnaps);
                    let last_three_score = 0;
                    ddd.forEach((a, index) => {
                      last_three_score =
                        last_three_score + a.data().CalibrationAvg;
                    });
                    last_three_score = last_three_score / 3;
                    if (last_three_score > CalibScore) {
                      sign = "down";
                    } else if (last_three_score < CalibScore) {
                      sign = "up";
                    }
                  }
                }
                newArray[index] = {
                  uid: change.doc.id,
                  ...change.doc.data(),
                  CalibScore,
                  sign
                };
                setAssignedUsers(newArray);
              }
              if (change.type === "removed") {
                let newArray = [...AssignedUsersRef.current];
                let index = newArray.findIndex(
                  user => change.doc.id === user.uid
                );
                newArray.splice(index, 1);
                setAssignedUsers(newArray);
              }
            });
          });
          ids = [];
        }
      }
      setLoading(false);
    }
    return unsubscribe;
  }, [assignedUserIds]);

  // Keep the ref in sync
  useEffect(() => {
    AssignedUsersRef.current = assignedUsers;
  }, [assignedUsers]);

  // Filter logic: if filterValidTill is ON, only show future validTill
  useEffect(() => {
    if (filterValidTill) {
      const now = new Date();
      const filtered = assignedUsers.filter(user => {
        if (!user.ValidTill) return true;
        return new Date(user.ValidTill) > now;
      });
      setFilteredAssignedUsers(filtered);
    } else {
      setFilteredAssignedUsers(assignedUsers);
    }
  }, [assignedUsers, filterValidTill]);

  // Toggle function
  const handleValidTillToggle = () => {
    setFilterValidTill(prev => !prev);
  };

  // Round function
  const roundOff = data => {
    return +(Math.round(data + "e+" + 1) + "e-" + 1);
  };

  // Remove a user from assigned
  const removeUser = async uid => {
    let docRef = doc(db, "SubAdminData", id);
    let removeDocRef = doc(db, "UserData", uid);
    await updateDoc(docRef, {
      AssignedUsers: arrayRemove(removeDocRef)
    });
    setAssignedUsers(assignedUsers.filter(userA => userA.uid !== uid));
  };

  // Table columns
  const columns = [
    {
      dataField: "FirstName",
      text: "Full Name",
      sort: true,
      formatter: (cell, row) => {
        return <div>{row.FirstName}</div>;
      },
      style: { cursor: "pointer" },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          history.push(`/user-details/${row.uid}`);
        }
      }
    },
    {
      dataField: "Email",
      sort: true,
      text: "Email",
      style: { cursor: "pointer" },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          history.push(`/user-details/${row.uid}`);
        }
      }
    },
    {
      isDummyField: true,
      dataField: "",
      text: "Action",
      formatter: (cell, row) => {
        return (
          <button
            type="button"
            className="btn btn-info"
            style={{ zIndex: 1 }}
            onClick={() => removeUser(row.uid)}
          >
            Remove
          </button>
        );
      }
    }
  ];

  // Pagination config
  const pagination = paginationFactory({
    sizePerPage: 50,
    hideSizePerPage: true
  });

  // Table's built-in search
  const SearchBar = props => {
    return (
      <input
        className="form-control"
        type="text"
        placeholder="Search in table"
        onChange={e => props.onSearch(e.target.value)}
      />
    );
  };

  // Custom search
  const searchStudent = async () => {
    setSearchLoading(true);
    setSerchedUsers([]);
    const collRef = collection(db, "UserData");
    const docQuery = query(collRef, where("Email", "==", searchEmail));

    const docs = await getDocs(docQuery);
    docs.forEach(doc => {
      setSerchedUsers(prev => [
        ...prev,
        { uid: doc.id, ref: doc.ref, ...doc.data() }
      ]);
    });
    setSearchLoading(false);
    setSearchEmail("");
  };

  // const searchStudents = async search_string => {
  //   setSearchEmail(search_string);
  //   if (search_string.length != 0) {
  //     let search = {
  //       q: search_string,
  //       query_by: "Email,FirstName"
  //     };
  //     typesenseClient
  //       .collections("UserData")
  //       .documents()
  //       .search(search)
  //       .then(function(searchResults) {
  //         setSerchedUsers([]);
  //         let docs = searchResults.hits;
  //         docs.forEach(({ document }) => {
  //           setSerchedUsers(prev => [
  //             ...prev,
  //             { uid: document.id, ...document }
  //           ]);
  //         });
  //       });
  //   } else {
  //     setSerchedUsers([]);
  //   }
  // };

  const addUser = async user => {
    let is_exists = assignedUsers.some(s => s.uid === user.uid);
    if (!is_exists) {
      let docRef = doc(db, "SubAdminData", id);
      let userRef = doc(db, "UserData", user.uid);
      await updateDoc(docRef, {
        AssignedUsers: arrayUnion(userRef)
      });
      setAssignedUsers(prev => [...prev, { ...user }]);
      setSerchedUsers([]);
    } else {
      alert("Student already added");
    }
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      {loading ? (
        <div className="wrapper">
          <div className="spinner">
            <div className="spinner-1"></div>
            <div className="spinner-2"></div>
            <div className="spinner-3"></div>
          </div>
        </div>
      ) : (
        <Row className="page-header py-4">
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-4 pb-3">
                <ToolkitProvider
                  keyField="uid"
                  data={filteredAssignedUsers}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {props => (
                    <div>
                      <h6
                        className="m-0 font-weight-bold"
                        style={{ marginBottom: "1rem" }}
                      >
                        Assigned Students List
                      </h6>

                      {/* Filter Toggle + Container for the two search bars */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "1rem",
                          marginBottom: "1rem"
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={filterValidTill}
                                onChange={handleValidTillToggle}
                                color="primary"
                              />
                            }
                            label="Valid Only"
                            style={{ marginRight: "8px" }}
                          />
                        </div>
                        {/* 1) Built-in table search */}
                        <div style={{ width: "250px" }}>
                          <SearchBar
                            {...props.searchProps}
                            className="form-control"
                          />
                        </div>

                        {/* 2) Custom search */}
                        <div style={{ width: "250px" }}>
                          <form style={{ display: "flex" }}>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search students"
                              value={searchEmail}
                              onChange={e => setSearchEmail(e.target.value)}
                            />
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginLeft: "8px" }}
                              onClick={searchStudent}
                            >
                              Search
                            </button>
                          </form>

                          {/* Show matched users */}
                          {searchedUsers.length > 0 && (
                            <div
                              className="searched_users_list_wrapper"
                              style={{ marginTop: "0.5rem" }}
                            >
                              <div className="searched_users_list">
                                {searchedUsers.map(user => (
                                  <div
                                    className="searched_users_list_item"
                                    key={user.uid}
                                  >
                                    <span>{user.Email}</span>
                                    <span className="icon">
                                      <i
                                        onClick={() => addUser(user)}
                                        className="material-icons"
                                      >
                                        add_circle
                                      </i>
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {searchLoading && <span>Searching...</span>}
                        </div>
                      </div>

                      {/* Table */}
                      <BootstrapTable
                        pagination={pagination}
                        {...props.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                {/* <BootstrapTable keyField='uid' data={Users} columns={columns} pagination={pagination} rowEvents={rowEvents} bootstrap4 /> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default SubAdminDetails;
